module.exports = __webpack_public_path__ + "static/use-browser-extension-mobile-afcc611e20dab94e4545e071afbbcaad.webp";